import MultiLineText from './MultiLineText'
export default MultiLineText
export type { IMultiLineTextProps } from './MultiLineText.types'
